<template>
  <div>
    <!--     <v-container>
      <v-simple-table class="mobile-friendly-table" dense>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">{{ $t("products.table.objectName") }}</th>
              <th class="text-left">{{ $t("products.table.name") }}</th>
              <th class="text-left">{{ $t("products.table.actions") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in items" :key="index">
              <td>{{ item.objectName }}</td>
              <td>{{ item.name }}</td>
              <td>
                <v-btn icon @click="toggleDetails(index)">
                  <v-icon>{{ expandedIndex === index ? "mdi-chevron-up" : "mdi-chevron-down" }}</v-icon>
                </v-btn>
              </td>
            </tr>
            <tr v-if="expandedIndex === index">
              <td colspan="3">
                <div class="details">
                  <div>
                    <strong>{{ $t("products.table.unitId") }}:</strong> {{ item.unitId || "-" }}
                  </div>
                  <div>
                    <strong>{{ $t("products.table.stationId") }}:</strong> {{ item.stationId || "-" }}
                  </div>
                  <div>
                    <strong>{{ $t("products.table.serialNumber") }}:</strong> {{ item.sn }}
                  </div>
                  <div>
                    <strong>{{ $t("products.table.plugType") }}:</strong> {{ item.plugType }}
                  </div>
                  <div>
                    <strong>{{ $t("products.table.powerType") }}:</strong> {{ item.powerType }}
                  </div>
                  <div>
                    <strong>{{ $t("products.table.latitude") }}:</strong> {{ Math.round(item.latLng[0] * 100) / 100 }}
                  </div>
                  <div>
                    <strong>{{ $t("products.table.longitude") }}:</strong> {{ Math.round(item.latLng[1] * 100) / 100 }}
                  </div>
                  <v-btn small color="primary" @click="emitSetPoint(item)"> <v-icon left>mdi-location-enter</v-icon>{{ $t("products.actions.enter") }} </v-btn>
                  <v-btn small :color="favoriteColor" @click="emitAddToFavorite(item)"> <v-icon left>mdi-cards-heart</v-icon>{{ $t("products.actions.favorite") }} </v-btn>
                </div>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-container>
 -->
    <v-simple-table>
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left" width="15%">
              {{ $t("products.table.projectName") }}
            </th>
            <th class="text-left" width="15%">
              {{ $t("products.table.objectName") }}
            </th>
            <th class="text-left" width="10%">
              {{ $t("products.table.name") }}
            </th>
            <!--             
            <th class="text-left" width="1%">
              {{ $t("products.table.unitId") }}
            </th>
            <th class="text-left" width="1%">
              {{ $t("products.table.stationId") }}
            </th> 
            -->
            <th class="text-left" width="5%">
              {{ $t("products.table.serialNumber") }}
            </th>
            <th class="text-left" width="4%">
              {{ $t("products.table.plugType") }}
            </th>
            <th class="text-left" width="4%">
              {{ $t("products.table.powerType") }}
            </th>
            <th class="text-left" width="4%">
              {{ $t("products.table.nominalPower") }}
            </th>
            <th class="text-left" width="4%">
              {{ $t("products.table.type") }}
            </th>
            <th class="text-left" width="4%">
              {{ $t("products.table.latitude") }}
            </th>
            <th class="text-left" width="4%">
              {{ $t("products.table.longitude") }}
            </th>
            <th class="text-left" width="8%">
              {{ $t("products.table.actions") }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, i) in items" :key="i">
            <td width="15%">{{ item.projectName }}</td>
            <td width="15%">{{ item.objectName }}</td>
            <td width="10%">{{ item.name }}</td>
            <!--            
             <template v-if="'unitId' in item">
              <td width="1%">{{ item.unitId }}</td>
            </template>
            <template v-else>
              <td width="1%"></td>
            </template>
            <template v-if="'stationId' in item">
              <td width="1%">{{ item.stationId }}</td>
            </template>
            <template v-else>
              <td width="1%"></td>
            </template> 
            -->
            <td width="5%">{{ item.sn }}</td>
            <td width="4%">{{ item.plugType }}</td>
            <td width="4%">{{ item.powerType }}</td>
            <td width="4%">{{ item.nominalPower }}</td>
            <td width="4%">{{ item.type }}</td>
            <td width="1%">{{ Math.round(item.latLng[0] * 100) / 100 }}</td>
            <td width="1%">{{ Math.round(item.latLng[1] * 100) / 100 }}</td>
            <td width="8%">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn class="mx-1" fab dark x-small color="primary" @click="emitSetPoint(item)" v-bind="attrs" v-on="on">
                    <v-icon dark> mdi-location-enter </v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("products.actions.enter") }}</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn class="mx-1" fab dark x-small @click="emitAddToFavorite(item)" :color="favoriteColor" v-bind="attrs" v-on="on">
                    <v-icon dark> mdi-cards-heart </v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("products.actions.favorite") }}</span>
              </v-tooltip>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>

    <v-snackbar v-model="snackbar.show" :timeout="1500" color="primary">
      {{ snackbar.message }}
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar.show = false"> Zavřít </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  name: "ProductsSimpleTable",
  props: {
    items: {
      type: Array,
      require: true,
    },
    favorites: {
      type: Array,
      require: true,
    },
  },
  data() {
    return {
      expandedIndex: null,

      disabled: false,

      snackbar: {
        show: false,
        message: "",
      },
    };
  },
  computed: {
    favoriteColor() {
      return "red";
    },
  },
  methods: {
    toggleDetails(index) {
      this.expandedIndex = this.expandedIndex === index ? null : index;
    },
    blockActions() {
      this.disabled = true;
      setTimeout(() => {
        this.disabled = false;
      }, 1500);
    },
    emitAddToFavorite(item) {
      if (this.disabled === true) {
        return;
      }
      this.blockActions();
      this.$emit("eventAddToFavorite", item);
      this.showSnackbar(this.$i18n.t("products.table.object") + " " + `${item.objectName} - ${item.sn}` + " " + this.$i18n.t("products.table.addToFavorite"));
    },
    emitSetPoint(item) {
      if (this.disabled === true) {
        return;
      }
      this.blockActions();
      this.$emit("eventSetPoint", item);
      this.showSnackbar(this.$i18n.t("products.table.object") + " " + `${item.objectName} - ${item.sn}` + " " + this.$i18n.t("products.table.setPoint"));
    },
    showSnackbar(message) {
      this.snackbar.message = message;
      this.snackbar.show = true;
    },
  },
};
</script>

<style scoped>
.mobile-friendly-table {
  overflow-x: auto;
}
.details {
  padding: 16px;
  background-color: #f9f9f9;
  border: 1px solid #ddd;
  border-radius: 4px;
}
</style>
